// extracted by mini-css-extract-plugin
module.exports = {"progressColorPrimaryMuted":"rgba(0,0,0,0)","progressColorFill":"#ffca41","progressColorPrimary":"#ffca41","contentMaxWidth":"192rem","wrapper":"deezer_wrapper__lM_LL"};